<div class="layout-container">
  <!-- BOOLEAN CHECKBOX -->

  @if (variable?.type === 'boolean') {
    <mat-checkbox [(ngModel)]="condition.operand"></mat-checkbox>
  }

  <!-- VARIABLE -->

  <mat-form-field class="variable" appearance="outline" floatLabel="always">
    <mat-label>Variable</mat-label>
    <mat-select [(ngModel)]="condition.variable">
      @for (variable of variables; track variable.name) {
        <mat-option [value]="variable.name">{{ variable.label }}</mat-option>
      }
    </mat-select>
  </mat-form-field>

  @if (variable) {
    @if (variable.type !== 'boolean') {

      <!-- COMPARISON OPERATOR -->

      <mat-form-field appearance="outline" floatLabel="always">
        <mat-label>Operator</mat-label>
        <mat-select [(ngModel)]="condition.operator">
          @for (operator of comparisonOperators; track operator) {
            @if (comparisonOperatorAllowed(operator.value)) {
              <mat-option [value]="operator.key">{{ operator.value.label }}</mat-option>
            }
          }
        </mat-select>
      </mat-form-field>

      <!-- VALUE -->

      @if (condition.operator === 'in') {
        <div class="in-operator">
          <div class="in-options">
            @for (index of indices(condition.operand); track index) {
              <div class="in-option">
                <tyt-condition-value-editor [type]="variable.type" [enumOptions]="variable.enumOptions" [value]="condition.operand[index]" (valueChange)="condition.operand[index] = $event" />
                @if (condition.operand.length > 1) {
                  <button mat-icon-button (click)="removeOperand(index)">
                    <mat-icon>close</mat-icon>
                  </button>
                }
              </div>
            }
          </div>
          <button mat-raised-button (click)="condition.operand.push(undefined)">
            <mat-icon>add</mat-icon>
            Add
          </button>
        </div>
      } @else if (condition.operator === 'regex') {
        <mat-form-field appearance="outline" floatLabel="always">
          <mat-label>Regular Expression</mat-label>
          <input type="text" matInput
            [errorStateMatcher]="regexValidator"
            [(ngModel)]="condition.operand"
            />
          <mat-hint><a target="_blank" href="https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_expressions/Cheatsheet">Reference</a></mat-hint>
          <mat-error>
            Invalid regular expression
          </mat-error>
        </mat-form-field>
      } @else {
        <tyt-condition-value-editor [type]="variable.type" [enumOptions]="variable.enumOptions" [(value)]="condition.operand" />
      }
    }
  }
</div>